module.exports = __webpack_public_path__ + "img/mytarget-img-3.914e0961.jpg";